import { Exercise as ComponentExercise, ExerciseType, FillInBlanksData } from "@/services/admin/exercises.interfaces";
import { EditorInterface } from "./EditorInterface";
import { FormInput } from "lucide-react";
import { ExerciseType as InternalExerciseType } from "./types";

/**
 * Editor para exercícios de preencher o texto (versão unificada)
 * Variação do FillInTheBlanks com foco em preencher textos com palavras específicas
 */
export class FillInTheTextInfo extends EditorInterface {
  /**
   * Retorna as informações para exibir no cartão do exercício
   * @param exercise Objeto do exercício
   */
  static GetCardInfo(exercise: ComponentExercise): {
    title: string;
    subtitle: string;
    description?: string;
  } {
    console.log("FillInTheTextInfo.GetCardInfo - Exercício recebido:", exercise);
    
    if (!exercise || !FillInTheTextInfo.SupportsExerciseType(exercise.type as unknown as string)) {
      console.log("FillInTheTextInfo.GetCardInfo - Exercício não suportado:", exercise?.type);
      return {
        title: 'Preencher o Texto',
        subtitle: 'Sem detalhes',
      };
    }

    try {
      // Tenta extrair os dados do exercício, lidando com diferentes formatos
      let text = 'Sem texto';
      let blanks: string[] = [];
      
      console.log("FillInTheTextInfo.GetCardInfo - Dados do exercício:", exercise.data);
      
      // Se os dados estiverem no formato aninhado (data é um objeto)
      if (exercise.data && typeof exercise.data === 'object') {
        const data = exercise.data as FillInBlanksData;
        text = data.text || 'Sem texto';
        blanks = data.blanks || [];
        console.log("FillInTheTextInfo.GetCardInfo - Dados extraídos do formato aninhado:", { text, blanks });
      } 
      // Se os dados estiverem no formato plano
      else if ('text' in exercise) {
        text = (exercise as any).text || 'Sem texto';
        blanks = (exercise as any).blanks || [];
        console.log("FillInTheTextInfo.GetCardInfo - Dados extraídos do formato plano:", { text, blanks });
      }
      
      // Conta o número de lacunas
      const blanksCount = blanks.length;
      
      const result = {
        title: "Preencher o Texto",
        subtitle: text.length > 60 ? `${text.substring(0, 60)}...` : text,
        description: blanksCount > 0 ? `${blanksCount} palavras` : "Sem palavras definidas",
      };
      
      console.log("FillInTheTextInfo.GetCardInfo - Resultado:", result);
      return result;
    } catch (error) {
      console.error("Erro ao processar dados do exercício de preencher o texto:", error);
      return {
        title: 'Preencher o Texto',
        subtitle: 'Erro ao processar dados',
      };
    }
  }
  
  /**
   * Retorna o título do tipo de exercício
   */
  static getTitle(): string {
    return "Preencher o Texto";
  }
  
  /**
   * Retorna uma descrição formatada para o exercício
   * @param exercise Objeto do exercício
   */
  static getDescription(exercise: ComponentExercise): string {
    if (!exercise) {
      return "Sem detalhes";
    }
    
    try {
      // Tenta extrair as palavras do exercício, lidando com diferentes formatos
      let blanks: string[] = [];
      
      // Se os dados estiverem no formato aninhado (data é um objeto)
      if (exercise.data && typeof exercise.data === 'object') {
        const data = exercise.data as FillInBlanksData;
        blanks = data.blanks || [];
      } 
      // Se os dados estiverem no formato plano
      else if ('blanks' in exercise) {
        blanks = (exercise as any).blanks || [];
      }
      
      const blanksCount = blanks.length;
      if (blanksCount > 0) {
        // Mostrar uma prévia das palavras se houver pelo menos uma
        const preview = blanks.slice(0, 3).join(', ');
        return blanksCount > 3 
          ? `${preview}, ... (${blanksCount} palavras)` 
          : `Palavras: ${preview}`;
      }
      return "Sem palavras definidas";
    } catch (error) {
      console.error("Erro ao processar dados do exercício:", error);
      return "Erro ao processar dados";
    }
  }
  
  /**
   * Retorna o ícone para o tipo de exercício
   */
  static getIcon() {
    return FormInput;
  }
  
  /**
   * Verifica se o exercício é do tipo Preencher o Texto
   */
  static SupportsExerciseType(type: string): boolean {
    return type === InternalExerciseType.FillInTheText;
  }
}